export default __webpack_public_path__ + "static/media/la_ferte-vidame09.cca585fb.jpg";